module.exports = __webpack_public_path__ + "static/img/packaging_3.8db71ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/articles/packaging_3.jpg
// module id = bk4X
// module chunks = 1